export default __webpack_public_path__ + "static/media/BANNER_BG.be63a844.png";